<template>
  <main>
    <SectionHero :variant="hero.variant">
      <OrganismHero :hero="hero" />
      <template #footerShort>
        <div class="flex flex-col md:flex-row flex-1 md:items-end h-full md:pb-6">
          <div class="flex flex-1">
            <TownDropdown :items="cityItems" @select="onCitySelect" />
          </div>
          <OrganismTabs :list="tabs" />
          <AtomButtonDropdown
            class="md:hidden w-full mt-3"
            :auto-width="true"
            :theme-light="true"
            :items="tabsDropdown"
            :initial-index="initialView"
            @select="onViewSelect"
          />
        </div>
      </template>
    </SectionHero>
    <SectionDefault>
      <NuxtChild :context="{ cityId: cityId }" />
    </SectionDefault>
  </main>
</template>

<script>
import AtomButtonDropdown from '../../components/atoms/AtomButtonDropdown'
import TownDropdown from '../../components/molecules/heroControls/TownsDropdown'
import OrganismHero from '../../components/organisms/layouts/OrganismHero'
import OrganismTabs from '../../components/organisms/layouts/OrganismTabs'
import SectionDefault from '../../components/templates/layouts/SectionDefault'
import SectionHero from '../../components/templates/layouts/SectionHero'

export default {
  name: 'SpaIndex',
  components: {
    OrganismTabs,
    SectionDefault,
    SectionHero,
    TownDropdown,
    OrganismHero,
    AtomButtonDropdown,
  },
  meta: {
    theme: 'dark',
  },
  data: c => {
    return {
      cityId: null,
      hero: {
        title1: 'ENCORE',
        title2: 'SPA',
        breadcrumbs: c.$breadcrumbs.spa(),
      },
      tabsDropdown: [
        { text: 'Списком', to: '/spa' },
        { text: 'На карте', to: '/spa/map' },
      ],
      tabs: [
        {
          title: 'На карте',
          to: '/spa/map',
        },
        {
          title: 'Список',
          to: '/spa',
        },
      ],
    }
  },
  computed: {
    cityItems() {
      return this.$store.getters['modules/content/getClubsTownsAsSpaDropdownWithAll']
    },
    initialView() {
      return this.$route.name === 'spa_map' ? 1 : 0
    },
  },
  methods: {
    onCitySelect(cityId) {
      this.cityId = cityId
    },
    onViewSelect(i) {
      const view = this.tabsDropdown[i]
      this.$router.push(view.to)
    },
  },
}
</script>
